/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_HideInputs */

const en_auth_password_hide = /** @type {(inputs: Auth_Password_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide password`)
};

const pl_auth_password_hide = /** @type {(inputs: Auth_Password_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukryj hasło`)
};

/**
* | output |
* | --- |
* | "Hide password" |
*
* @param {Auth_Password_HideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_password_hide = /** @type {((inputs?: Auth_Password_HideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_HideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_password_hide(inputs)
	return en_auth_password_hide(inputs)
});